import { maxBreakpoints, minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { MODAL_CONTENT_CLASS_NAMES } from '@noths/polaris-client-ribbons-design-system';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { createGlobalStyle, css } from 'styled-components';

const { fonts, spacing } = theme;

const font = css`
  ${theme.responsiveText.BODY.MD};
  color: var(--neutral-black-base);
`;

export const AddToBasketModalGlobalStyles = createGlobalStyle`
  .${MODAL_CONTENT_CLASS_NAMES.base} {
    ${mediaQuery(
      { min: minBreakpoints.L },
      css`
        grid-column: 3 / -3;
      `,
    )}
  }
`;

export const addToBasketSection = css`
  display: flex;
  align-items: center;
  margin: ${spacing.xl}px;
  ${theme.responsiveText.BODY.XS};

  p,
  a,
  span {
    ${theme.responsiveText.BODY.XS};
    line-height: 1.67;
  }
`;

export const footerItems = css`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
`;

export const productDescription = css`
  margin: 0;
`;

export const addToBasketProductSection = css`
  gap: ${pxToRem(80)};
  flex-wrap: wrap;
  border-radius: ${pxToRem(20)};
  border: solid ${pxToRem(1)} var(--neutral-black-30);
  padding: ${spacing.xl}px;
`;

export const buttonContainer = css`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  width: 100%;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      flex-basis: ${pxToRem(500)};
      flex-direction: row;
      justify-content: flex-end;
      column-gap: 16px;
    `,
  )}
`;

export const basketInfo = css`
  display: flex;
  flex-grow: 1;
  ${theme.responsiveText.BODY.XS};

  ${mediaQuery(
    { max: maxBreakpoints.S },
    css`
      justify-content: center;
    `,
  )}
`;

export const basketInfoTotal = css`
  margin-right: ${spacing.sm}px;
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};

  ${mediaQuery(
    { max: maxBreakpoints.S },
    css`
      margin-top: 0;
    `,
  )}
`;

export const basketInfoItems = css`
  ${mediaQuery(
    { max: maxBreakpoints.S },
    css`
      margin-top: 0;
    `,
  )}
`;

export const addToBasketHeaderSection = css`
  margin: 0;
`;

export const addToBasketButtonSection = css`
  margin: ${spacing.xl}px;
`;

export const addToBasketHeader = css`
  margin: 0 ${spacing.xs}px;
  ${theme.responsiveText.BODY.MD};
`;

export const productInfo = css`
  display: flex;
  flex: 1;
  flex-basis: 50%;
  align-self: flex-start;
`;

export const productImage = css`
  margin-right: ${spacing.md}px;
  border-radius: ${pxToRem(10)};
`;

export const basketBreakdownWrapper = css`
  flex: 1 1 12.5rem;
  align-self: flex-start;
`;

export const priceBreakdownContainer = css`
  display: grid;
  grid-template-columns: 1fr 1fr;
`;

export const priceBreakdownTotal = css`
  grid-column: 1 / 3;
  padding-bottom: ${spacing.xxl}px;

  ${mediaQuery(
    { max: maxBreakpoints.M },
    css`
      padding-bottom: ${spacing.sm}px;
    `,
  )}
`;

export const priceBreakdownPrice = css`
  grid-column: 4 / -1;
`;

const gridLabel = css`
  grid-column: 1 / 3;
`;

const gridPrice = css`
  grid-column: 4 / -1;
`;

export const priceLabel = css`
  ${font};
  ${gridLabel};
  margin: 0;
`;

export const priceAmount = css`
  ${font};
  ${gridPrice};
  margin: 0;
`;

export const totalDivider = css`
  grid-column: 1/4;
  border-top: 1px solid black;
  padding-top: ${spacing.base}px;
`;

export const totalLabel = css`
  ${priceLabel};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
`;

export const totalPrice = css`
  ${priceAmount};
  ${gridPrice};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
`;

export const hyperButtonLink = css`
  a {
    cursor: none;
    text-align: left;
  }
`;
